<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-group">
	<!--		-->
	<!-- Info	-->
	<!--		-->
	<div class="main-group-item">
		<div class="main-group-item-center">
			<label class="main-group-title">{{ TotalCards }} total card(s) in shipment</label>
		</div>
	</div>

	<!--			 -->
	<!-- Info (FYI)  -->
	<!--	 		 -->
	<!-- <div class="main-group-item" style="margin-top:0px">
		<div class="main-group-item-center-padding">
			<label class="main-group-info">Note: </label>
		</div>
	</div> -->

	<!-- 		   -->
	<!-- Ship Date -->
	<!-- 		   -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">Ship Date</label>
			</div>

			<div style="margin-left: 10px; width: 235px">
				<label class="group-item-label-data">{{ ShipmentDT | date : "M/d/yyyy h:mm a" }}</label>
			</div>
		</div>
	</div>

	<!-- 		   		 -->
	<!-- Tracking Number -->
	<!-- 		  		 -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">Tracking Number</label>
			</div>

			<div style="margin-left: 10px; width: 235px">
				<label class="group-item-label-data">{{ ShipperTrackingNumber }}</label>
			</div>
		</div>
	</div>

	<!-- 		   	  -->
	<!-- Total Blocks -->
	<!-- 		  	  -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">Block Count</label>
			</div>

			<div style="margin-left: 10px; width: 235px">
				<label class="group-item-label-data">{{ TotalBlocks }}</label>
			</div>
		</div>
	</div>

	<!-- 			   -->
	<!-- Ship Comments -->
	<!-- 		 	   -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">Ship Comment</label>
			</div>

			<div style="margin-left: 10px; width: 235px">
				<textarea
					class="group-item-label-sdata"
					rows="3"
					cols="35"
					pInputTextarea
					autoResize="autoResize"
					disabled="true"
					[(ngModel)]="ShipComment"
				></textarea>
			</div>
		</div>
	</div>

	<!-- 			  -->
	<!-- Receive Date -->
	<!-- 		 	  -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">Receive Date</label>
			</div>

			<div style="margin-left: 10px; width: 235px">
				<p-calendar
					[style]="{ width: '100%' }"
					[inputStyle]="{ width: '100%' }"
					[(ngModel)]="ReceiveDT"
					[showTime]="true"
					hourFormat="12"
					showIcon="true"
					inputId="time"
				></p-calendar>
			</div>
		</div>
	</div>

	<!-- 		 	   	 	     -->
	<!-- Receive Status Selector -->
	<!-- 					     -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">Status</label>
			</div>

			<div style="margin-left: 10px; width: 235px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select class="form-control" name="SelectedReceiveStatusSelector" [(ngModel)]="SelectedReceiveStatus" (ngModelChange)="onStatusChange($event)">
					<option *ngFor="let r of lstReceiveStatusItems" [ngValue]="r">
						{{ r.MTACardShipmentStatusDesc }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!-- 		  		  -->
	<!-- Receive Comments -->
	<!-- 		  		  -->
	<div class="main-group-item">
		<div class="group-item">
			<div>
				<label class="group-item-label">Receive Comment</label>
			</div>

			<div style="margin-left: 10px; width: 235px">
				<textarea class="group-item-label-rdata" rows="3" cols="35" pInputTextarea autoResize="autoResize" [(ngModel)]="ReceiveComment"></textarea>
			</div>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="main-group-item" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<!-- Need to make room for date picker dropwown -->
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onUpdate()" [disabled]="isBusy == true">Update</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
